import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=27c2594e&scoped=true&"
import script from "./TermsModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TermsModal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./TermsModal.vue?vue&type=style&index=0&id=27c2594e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c2594e",
  null
  
)

export default component.exports